import { useNavigate } from 'react-router-dom';
import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';

/**
 * Экран 2.9.3 «Подтверждение отправки» — Блок 9 (ADR-0086, PRD 2.9.3).
 *
 * Success-экран после удачного submit анкеты 2.9.2 (`navigate('/cooperation/sent')`).
 * Структурно — копия `features/feedback/FeedbackConfirm.tsx`. Header title
 * «Сотрудничество», BottomBar variant=default.
 *
 * **Naming nuance (как FeedbackConfirm):** primary CTA — «Готово», а не «На
 * главную», потому что BottomBar (default) тоже содержит «На главную» — иначе
 * `getByRole('button', { name: 'На главную' })` нашёл бы две. Behaviorally
 * эквивалентно: «Готово» → `navigate('/')`.
 */
export function CooperationConfirm() {
  const navigate = useNavigate();

  return (
    <>
      <main className="min-h-screen flex flex-col bg-canvas">
        <Header title="Сотрудничество" />

        <section className="flex-1 p-6 overflow-y-auto flex flex-col gap-5 items-center justify-center">
          <h1 className="font-display text-h1 text-ink m-0 text-center">Заявка принята</h1>
          <p className="text-ink text-[18px] text-center max-w-[320px]">
            Мы свяжемся с вами в течение 1–2 рабочих дней.
          </p>
          <button
            type="button"
            onClick={() => navigate('/')}
            aria-label="Готово"
            className={[
              'w-full min-h-tap rounded-lg bg-cta border-b-2 border-cta-shadow text-ink',
              'font-bold text-[18px] py-3',
              'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90',
            ].join(' ')}
          >
            Готово
          </button>
        </section>
      </main>
      <BottomBar variant="default" />
    </>
  );
}
